import { render, staticRenderFns } from "./delivery-point-dadata-cdek.vue?vue&type=template&id=344c4a0e&scoped=true"
import script from "./delivery-point-dadata-cdek.vue?vue&type=script&lang=js"
export * from "./delivery-point-dadata-cdek.vue?vue&type=script&lang=js"
import style0 from "./delivery-point-dadata-cdek.vue?vue&type=style&index=0&id=344c4a0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c4a0e",
  null
  
)

export default component.exports